import React from 'react';
import GrayCard from '../../../components/GrayCardMemberData';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'c3/c3.css';
import Select from 'react-select';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import Axios from 'axios';
import { ROOT_URL } from '../../../actions';
import {
    getVendorFullInfo, getOutsidePurchaseProductCategory, getMemberPurchaseWithinImarkValue, getMemberPurchaseOutsideImarkValue,
    getMemberOutsidePurchaseByCategory, getMemberVendorNames, getCardsDataForMemberDataTab,
    saveOutVendorFeedback, saveProductFeedback, getTerminatedVPNamesForMember, getLPGNamesForMember,
    getProductCategory, getMemberBranch, getmemberQualification,getmemberQualification2021, getMemberMonthsFilter,
    tabTracking,getmemberPurchases
} from '../../../actions';
import './Member.css';
import '../../../components/Modal';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
// import Filters from '../../../components/FilterMember.jsx';
import Modal from '../../../components/Modal';
import { getCardTitle, PriceFormatter, dynamicDateFilters, monthName1, jsonToParam, paramsToJSON1, paramsToJSON, PercentFormatter, dynamicDateFilters1 } from '../../../helper';
import accounting from 'accounting-js';
import { Dropdown, Checkbox } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import ReactExport from "react-export-excel";
import _find from 'lodash/find';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { matLoader } from '../../../components/Loader';
import { Card, Form, Button, OverlayTrigger, Tooltip, select } from 'react-bootstrap';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import MembershipQualification from '../VerifiedData/membership-qualification';
import MembershipQualificationWireframe from '../VerifiedData/wireframe'
import { Modelpopup } from '../../../components/ModelPopUp';
import {ModelpopupQualification} from '../../../components/ModelpopupQualification'
import cloneDeep from 'lodash/cloneDeep';

// import FeedbackOutVendorForm from './FeedbackOutVendorForm'

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie(cname) {
    return getCookie(cname) && getCookie(cname) !== '';
}
class MemberData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            compliantvalue: false,
            selectedCheckboxes: '',
            showAllProductFeedbackModal: false,
            BranchNames: [],
            selectedBranch: "All Branch Summary",
            selectedFilter: "YTD",
            buttonOptions: ["MTH", "YTD", "QTR"],
            showQuarter: false,
            dataval: [],
            items: [],
            selectedYear: new Date().getFullYear(),
            selectedItem: new Date().getMonth(),
            suggestedFavorableVp: '',
            suggestedCategoryName: '',
            suggestedCategoryId: '',
            disableNewProductCategoryDropdown: true,
            disableVendorDropdown: true,
            disableInVendorDropdown: true,
            selectInVendorErrorMessage:'',
            selectFavorableVpErrorMessage: '',
            numberOfFavorableVp: '',
            showPopUpForFavorableVp: false,
            selectedFavorableVp: '',
            selectedCategory: '',
            selectedCategoryId: '',
            selectedProduct: '',
            selectedProductId: '',
            feedbackToggle: '',
            response: '',
            addModalShow: false,
            // firstPopUp: false,
            firstPopUp: true,
            isLoading: true,
            purchaseWithinImark: false,
            purchaseWithinImarkCriteria: false,
            vendorPartnerOptions: [],
            programNameOptions: [],
            selectedVendorPartner: null,
            selectedProgramName: null,
            rebateCardData: [],
            params: {
                period: "YTD",
                ytd: "true",
                qtr: "false",
                mth: "false",
                year: 2022,
                month: 1,
                quarter: 1,
                "memberId": this.props.memberIdForCorporate1,
                buyingGroupId: this.props.buyingGroupId,
                outVednor: "",
                productGroupId: "",
                verifiedSource: false,
            },
            showFeedbackModal: false,
            displayModal: false,
            propsForModal: {

            },
            classigicationFlag: [
                { flag: 'IN', text: 'In IMARK Supplier' },
                { flag: 'BUYSELL', text: 'Buysell Rep Supplier' },
                { flag: 'LPG', text: 'Lpg Supplier' },
                { flag: 'PARENT', text: 'Map to existing Out Supplier' },
                { flag: 'EXCLUDE', text: 'No Competitive IMARK Supplier' },
                { flag: 'NP', text: 'Non Plumbing Supplier' },
                { flag: 'MEMBER_COMPANY', text: 'Purchase from Member Company' },
                { flag: 'BRANCH_COMPANY', text: 'Purchase from Own Branch Company' },
                { flag: 'DIFF_BUYING_GROUP', text: 'Rebates Run Through Another Buying Group' }
            ],
            showSugestedVendorSelect: false,
            showLPGVendorSelect: false,
            showVendorNameInput: false,
            vendorDisplayName: '',
            suggestedVendorId: '',
            suggestedVendorName: '',
            feedbackComments: '',
            hide: false,
            // memberId: this.props.memberIdForCorporate,

            cardData: [],
            showProductsModal: false,
        }
        this.MemberPurchaseInsideImarkValue = [];
    }

    handleFlagChange = classification => {
        //  ;
        console.debug('Selected Flag', classification);
        this.setState(classification.flag === 'PARENT' ? {
            showSugestedVendorSelect: false,
            showVendorNameInput: true,
            showLPGVendorSelect: false,
        } : this.setState(classification.flag === 'NP' ? {
            showSugestedVendorSelect: false,
            showVendorNameInput: false,
            showLPGVendorSelect: false,
        }:
            this.setState(classification.flag === 'MEMBER_COMPANY' ? {
                showSugestedVendorSelect: false,
                showVendorNameInput: false,
                showLPGVendorSelect: false,
            } :
                this.setState(classification.flag === 'BRANCH_COMPANY' ? {
                    showSugestedVendorSelect: false,
                    showVendorNameInput: false,
                    showLPGVendorSelect: false,
                } :
                this.setState(classification.flag === 'DIFF_BUYING_GROUP' ? {
                    showSugestedVendorSelect: false,
                    showVendorNameInput: false,
                    showLPGVendorSelect: false,
                } :
                    this.setState(classification.flag === 'LPG' ? {
                        showLPGVendorSelect: true,
                        showSugestedVendorSelect: false,
                        showVendorNameInput: false,

                    } : {
                            showSugestedVendorSelect: true,
                            showVendorNameInput: false,
                            showLPGVendorSelect: false,
                        }))))));

        classification = classification.flag
        this.setState({ classificationFlag: classification })

    }

    handleUserSelectedFilter(option) {
        let obj = {};

        if (option === "qtr" || option === "QTR") {
            this.setState({ showQuarter: true });
        } else {
            this.setState({ showQuarter: false });
        }

        let paramsValues = this.state.params;
        let paramsfinal = paramsToJSON1(paramsValues);
        let month = paramsfinal.month;
        if (month >= 1 && month <= 3) {
            paramsfinal.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            paramsfinal.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            paramsfinal.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            paramsfinal.quarter = 4
        }

        let params = jsonToParam(paramsfinal);
        this.setState({ selectedFilter: option, params: params }, () => {
            this.setFilter({ period: this.state.selectedFilter, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });

    }

    colseModal = value => {
        // ;
        this.setState({ firstPopUp: false });
    };

    componentWillMount() {
        let paramsValues = this.state.params;
        // if (paramsValues.buyingGroupId === "1") {
        //     this.setState({ purchaseWithinImarkCriteria: true })
        // }
        // else {
        //     this.setState({ purchaseWithinImark: true })
        // }
        let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });

    }

    isExpanded = (action) => {
        if (action === true) {
            this.setState({ expanded: true });
        } else if (action === false) {
            this.setState({ expanded: false });

        }
    }

    componentDidMount() {
        
        let paramsValues = this.state.params;
        paramsValues = paramsToJSON(paramsValues);
        if (paramsValues.buyingGroupId === "1") {
            this.setState({ purchaseWithinImarkCriteria: true })
        }
        else {
            this.setState({ purchaseWithinImark: true })
        }

        console.log('filters ', this.props.showMonth == "false");
        console.log(this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptions: ["YTD", "QTR"], selectedFilter: "YTD" });
        }
        
        
        Axios.get(ROOT_URL + '/compliant?memberId=' + (paramsValues.memberId))
            .then(resp => this.setState
                ({ 
                    compliantvalue: resp.data ,
                    addModalShow1: !resp.data,
                    addModalShow: !resp.data && !sessionStorage.getItem('flag')
                }));

        let params = jsonToParam(paramsValues);
        Promise.all([

           // this.props.getCompliantValueAPI(this.state.params),
            this.props.getMemberMonthsFilterAPI(this.state.params),
            this.props.getMemberBranchAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=3"),
        ]).then(data => {
            this.getOptions();
            this.getOptionsYear();
            this.getBranchList();
            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
           // window.location.reload();

        })
        
        let checkStorage = localStorage.setItem('flag','11')
        setTimeout(function () { localStorage.removeItem("flag"); }, 2000);
      

    }

    closeModal = () => {
        this.setState({ showProductsModal: false, disableNewProductCategoryDropdown: true });
    }
    displayModal() {
        if (this.state.displayModal === true) {
            // render table or card according to modaltype

            return (
                <Modal parentView="MemberData" modalType="table" width="400px" propsForModal={this.state.propsForModal} closeModal={this.closeModal} />
            )
        } else {
            return (
                <div className="modal fade" tabIndex="-1" role="dialog">

                </div>
            )
        }
    }

    displayModalMethod = (propsForModal) => {

        this.setState({ displayModal: true, propsForModal: propsForModal });
    }
    handleChangeOfDropdown(event) {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let obj = {};
        obj[event.name] = event.value;
        params.quarter = event.value;
        let quarter = params.quarter
        params = jsonToParam(params);
        this.setState({
            quarter: quarter,
            params: params
        })
        this.setState(obj, () => {
            this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
        });

    }

    handleChangeOfDropdownYear(e) {
        
        let params = this.state.params;
        params = paramsToJSON1(params);
        let year = ''
        let items =[]
        params.year = e.value
        year = params.year
        let selectedYear = { label: year, value: year }
        // let memberId=params.memberId;
        let dataval = Object.keys(this.props.getMemberMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })

        let selectedYear1 = yearval[yearval.length - 1];
        // if (selectedYear1.value != 2023 && e.value == 2023 )
        if (selectedYear1.value != 2024 && e.value == 2024 )
        {
            items = [{ label: monthName1(1),value: 1}];
        }
        else {
        let dataval1 = Object.values(this.props.getMemberMonthsFilter[year]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }
        }
        
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedYear: selectedYear,
            items: items,
            selectedItem : selectedItem,
        },this.getBranchList)
       // params = paramsToJSON(params);


        let allmemberArr1 = [];
        
        let BranchNameObj = [];
        this.props.getMemberBranchAPI(params).then(res => {

            let memberId = ''
            res.map((data, index) => {
                allmemberArr1.push(_get(data, 'branchId', ''));
            })
            BranchNameObj = res.map((data, index) => {
                return {
                    // key: index,
                    label: data.branchId + "--" + data.branchName,
                    value: data.branchId
                }
            })
            
            // memberId = allmemberArr1[0];

            BranchNameObj.unshift({ label: "All Branch summary", value: this.props.allmemberArr1 });
            let selectedBranch = BranchNameObj[0]
            params = paramsToJSON(params);
            params.memberId = BranchNameObj[0].value;
            memberId = params.memberId
            params.month = this.state.selectedItem.value;
            month = params.month
            if (month >= 1 && month <= 3) {
                params.quarter = 1
            }
            else if (month >= 4 && month <= 6) {
                params.quarter = 2
            }
            else if (month >= 7 && month <= 9) {
                params.quarter = 3
            }
            else if (month >= 10 && month <= 12) {
                params.quarter = 4
            }
            params = jsonToParam(params);
            this.setState({
                BranchNames: BranchNameObj,
                params: params,
                selectedYear: selectedYear,
                items: items,
                selectedItem : selectedItem,
                selectedBranch: selectedBranch,
                month: month
            })
            this.setState(e, () => {
                this.setFilter({ year: this.state.year, memberId: memberId, selectedYear: selectedYear,selectedItem:selectedItem });
            });

        })
        
    }
    getOptionsYear() {
        
        let dataval = Object.keys(this.props.getMemberMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })

        let selectedYear = yearval[yearval.length - 1];
        if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        else if (selectedYear.value != 2023 && selectedYear.value != 2024){
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });
  
        }
        //add this new code
        else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }
        
        // params = jsonToParam(params);
        this.setState({
            selectedYear: selectedYear,
            yearval: yearval,
            // params: params ,
        })
        
    }
    getBranchList() {
        
        let params = this.state.params;
        params = paramsToJSON(params);
        let BranchNameObj = [];
        BranchNameObj = this.props.getMemberBranch.map((vname, index) => {
            return {
                label: vname.branchId + "--" + vname.branchName,
                value: vname.branchId
            }
        })
        BranchNameObj.unshift({ label: "All Branch summary", value: this.props.allmemberArr1 });
        let selectedBranch1 = BranchNameObj[0];
        params.memberId = selectedBranch1.value;
        params = jsonToParam(params)
        this.setState({
            BranchNames: BranchNameObj,
            selectedBranch: selectedBranch1,
            params: params
        })
        this.props.getCardsDataForMemberDataTabAPI(params)
        this.props.getMemberPurchaseWithinImarkValueAPI(params)
        this.props.getMemberPurchaseOutsideImarkValueAPI(params)
        this.props.getMemberOutsidePurchaseByCategoryAPI(params)
        this.props.getTerminatedVPNamesForMemberAPI(params)
        this.props.getProductCategoryAPI(params)
        this.props.getLPGNamesForMemberAPI(params)
        
    }

    getOptions() {
        
        let params = this.state.params;
        params = paramsToJSON(params);
        let items = []
        let dataval = Object.keys(this.props.getMemberMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];

        let dataval1 = Object.values(this.props.getMemberMonthsFilter[selectedYear1.value]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }

        if (selectedYear1.value != 2022)
        {
        yearval.push({ label: 2022, value: 2022 });
        }
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        params.year = selectedYear1.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params,
        })
        
    }


    renderButtonGroup() {

        return this.state.buttonOptions.map((option, index) => {
            return (
                <button key={index} type="button" style={{ height: '38px' }} value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilter === option) ? "active" : null}`}>{option}</button>
            )
        })
    }
    handleClickBranch = (e) => {
        
        let params = this.state.params;
        params = paramsToJSON1(params);
        let year=params.year;
        let selectedBranch = { label: e.label, value: e.value }
        let arr = [];
        let valstr = [e.value];
        if (valstr != "" && valstr != "undefined") {
            // let valueee = valstr.map((option, index) => {
            // let val = _find(value.options, ['value', option])
            arr.push(valstr)
            // })
            params.memberId = arr
        }
        else {
            params.memberId = this.props.memberIdForCorporate

        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedBranch: selectedBranch,
        })
    if(year ==2021)
    {
        
        this.props.getmemberQualification2021API(params)
    }
    else
    {
     
        this.props.getmemberQualificationAPI(params)
    }
   
        this.props.getmemberPurchasesAPI(params)
        this.props.getCardsDataForMemberDataTabAPI(params)
        this.props.getMemberPurchaseWithinImarkValueAPI(params)
        this.props.getMemberPurchaseOutsideImarkValueAPI(params)
        this.props.getMemberOutsidePurchaseByCategoryAPI(params)
        this.props.getTerminatedVPNamesForMemberAPI(params)
        this.props.getProductCategoryAPI(params)
        this.props.getLPGNamesForMemberAPI(params)



    }

    handleChangeOfDropdownMonth = (e) => {
        
        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month = params.month
        let year=params.year;
        let selectedItem = { label: monthName1(month), value: month }
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,

        })
        if(year ==2021)
        {
            
            this.props.getmemberQualification2021API(params)
        }
        else
        {
         
            this.props.getmemberQualificationAPI(params)
        }
        this.props.getmemberPurchasesAPI(params)
        this.props.getCardsDataForMemberDataTabAPI(params)
        this.props.getMemberPurchaseWithinImarkValueAPI(params)
        this.props.getMemberPurchaseOutsideImarkValueAPI(params)
        this.props.getMemberOutsidePurchaseByCategoryAPI(params)
        this.props.getTerminatedVPNamesForMemberAPI(params)
        this.props.getProductCategoryAPI(params)
        this.props.getLPGNamesForMemberAPI(params)

        
    }


    setFilter = (filter) => {
        let params = this.state.params;
        params = paramsToJSON1(params);
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";
            //  params.quarter = filter.quarter;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {
            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            // params.month = filter.month;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            // params.year = filter.year;
            // params.month = filter.month;
            params.period = filter.period;
        }
        else if (filter.memberId != undefined) {
            params.memberId = filter.memberId;

        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            isLoading: true
        }, () => Promise.all([
            // this.props.getMemberBranchAPI(this.state.params),
            this.props.getCardsDataForMemberDataTabAPI(params),
            this.props.getMemberPurchaseWithinImarkValueAPI(params),
            this.props.getMemberPurchaseOutsideImarkValueAPI(params),
            this.props.getMemberOutsidePurchaseByCategoryAPI(params),
            this.props.getTerminatedVPNamesForMemberAPI(params),
            this.props.getProductCategoryAPI(params),
            this.props.getLPGNamesForMemberAPI(params),

        ]).then(data => {

            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))

    }
    renderSizePerPageDropDown = props => {
        return (
            <div className='btn-group'>
                {
                    [25, 50, 100].map((n, idx) => {
                        const isActive = (n === props.currSizePerPage) ? 'active' : null;
                        return (
                            <button key={idx} type='button' className={`btn btn-info ${isActive}`} onClick={() => props.changeSizePerPage(n)}>{n}</button>
                        );
                    })
                }
            </div>
        );
    }
    // var sortedArray = nonSortedArray.sort(function (a, b) {
    //     if (a < b) return -1;
    //     else if (a > b) return 1;
    //     return 0;
    //   });
    // console.log(sortedArray);

    showPopUpForFavorableVp1 = (cell, row) => {
        if (_isEmpty(row.vendor1)) {
            return (
                <div></div>
            )
        }
        return (
            // <div>{row.favorableVendor2Name} <Link onClick={(e) => this.showModalForFavorableVendor(2, row,row.favorableVendor2Id, row.favorableVendor2Name)}><i class="fas fa-comment-alt"></i></Link></div>

            <div> <Link onClick={(e) => this.showModalForFavorableVendor(1, row, row.vendor1)}>{row.vendor1} <i class="fas fa-comment-alt"></i></Link></div>
        )
    };
    showPopUpForFavorableVp2 = (cell, row) => {
        if (_isEmpty(row.vendor2)) {
            return (
                <div></div>
            )
        }
        return (
            <div> <Link onClick={(e) => this.showModalForFavorableVendor(2, row, row.vendor2)}>{row.vendor2} <i class="fas fa-comment-alt"></i></Link></div>
        )
    };
    showPopUpForFavorableVp3 = (cell, row) => {
        if (_isEmpty(row.vendor3)) {
            return (
                <div></div>
            )
        }
        return (
            <div> <Link onClick={(e) => this.showModalForFavorableVendor(3, row, row.vendor3)}>{row.vendor3} <i class="fas fa-comment-alt"></i></Link></div>
        )
    };
    showPopUpForFavorableVp4 = (cell, row) => {
        if (_isEmpty(row.vendor4)) {
            return (
                <div></div>
            )
        }
        return (
            <div> <Link onClick={(e) => this.showModalForFavorableVendor(4, row, row.vendor4)}>{row.vendor4} <i class="fas fa-comment-alt"></i></Link></div>
        )
    };
    showModalForFavorableVendor = (num, row, vpSelected) => {
        this.setState({ numberOfFavorableVp: num, selectedCategory: row.categoryName, selectedFavorableVp: vpSelected, showPopUpForFavorableVp: true })
    }

    closeFavorableVendorModal = () => {
        this.setState({ showPopUpForFavorableVp: false });
    }
    showCommentIcon = (cell, row) => <div onClick={(e) => { console.log('aabc ', row); this.showProductsModal(row) }}><i class="fas fa-comment-alt">Comment</i></div>;

    showProductsModal = (row) => {
        //;
        this.setState({
            selectedCategoryId: row.categoryId, selectedCategory: row.categoryName,
            showProductsModal: true, showAllProductFeedbackModal: false
        }, () => {
            let selections = this.state.params;
            console.log(typeof (selections));
            selections.selectedCategoryId = this.state.selectedCategoryId;
            console.log(selections);
            this.props.getMemberDataUnapprovedSupplierPurhcaseByCategoryPopUpAPI(selections);
        })
    }

    // sendFeedbackForFavorableVendor() {


    //     let selections = {
    //         productId: null,
    //         productDescription: "",
    //         bhCategoryId: null,
    //         favorableSupplierId: null,
    //         favorableSupplierWrong: 1,
    //         favorableSupplierIdSuggested: 4545,
    //         favorableSupplierNameSuggested: this.state.suggestedFavorableVp,
    //         favorableVpRank: this.state.numberOfFavorableVp,
    //         favorableSupplierName: this.state.selectedFavorableVp,
    //         bhCategoryName: this.state.selectedCategory,
    //         comments: ''
    //     }
    //     if (!this.state.suggestedFavorableVp) {
    //         this.setState({ selectFavorableVpErrorMessage: 'Please select a vendor' }, () => {
    //         });
    //     } else {
    //         this.setState({ showPopUpForFavorableVp: false, selectFavorableVpErrorMessage: '' }, () => {
    //             // this.props.insertFeedbackFavorableSupplierFeedbackAPI(selections, (res) => {
    //             //     swal(res.data.message);
    //             // });
    //             swal('Feedback submitted successfully');

    //         });
    //     }
    //     //call action now
    // }
    createCustomClearButtonForOutsidePurchase = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{'height': '24px','font-size': '11px','font-weight': '700',
                'font-stretch': 'extra-expanded'}}
                onClick={(e) => this.getPurchseOutsideImarkDefaultData(onClick)}
            >
            Clear All
            </button>
        );
    };

    createCustomClearButtonForOutsidePurchaseProductGroup= (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{height:'25px',float: "right" }}
                onClick={(e) => this.getProductGroupDefaultData(onClick)}
            >
            Clear All
            </button>
        );
    };
    handleRowClick = row => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.outVendor = (row.vendorName);
        params = jsonToParam(params);
        this.props.getMemberOutsidePurchaseByCategoryAPI(params);
    }
    handleRowClickOutsidePurchase = row => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.productGroupId = (row.tierFourId);
        params = jsonToParam(params);

        this.props.getMemberPurchaseOutsideImarkValueAPI(params);
    }

    handleRowClickCategory = row => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.dropDown = [{ "bhCategoryName": [row.categoryName] }]

        this.props.getUnapprovedSuppliersAPI(params);
    }
    getPurchseInsideImarkDefaultData = (onClick) => {
        onClick();
        this.refs.purchasewithinimarkmember.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.outVendor = "";
        params = jsonToParam(params);
        this.setState({ selectedStates: [], params: params, })
        this.props.getMemberPurchaseWithinImarkValueAPI(params);
        this.props.getMemberPurchaseOutsideImarkValueAPI(params);
        this.props.getMemberOutsidePurchaseByCategoryAPI(params);
        // this.refs.table1.reset();
         this.refs.purchasewithinimarkmember.reset();
    }
    getPurchseOutsideImarkDefaultData = onClick => {
        onClick();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.outVendor = "";
        params = jsonToParam(params);
        this.setState({ selectedStates: [], params: params, })
        this.props.getMemberPurchaseWithinImarkValueAPI(params);
        this.props.getMemberPurchaseOutsideImarkValueAPI(params);
        this.props.getMemberOutsidePurchaseByCategoryAPI(params);
        this.refs.table1.reset();
        this.refs.table2.reset();
    }
    getProductGroupDefaultData = (onClick) => {
        onClick();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.productGroupId = '';
        params = jsonToParam(params);
        this.setState({ selectedStates: [], params: params, })
        this.props.getMemberPurchaseWithinImarkValueAPI(params);
        this.props.getMemberOutsidePurchaseByCategoryAPI(params);
        this.props.getMemberPurchaseOutsideImarkValueAPI(params);
        this.refs.table1.reset();
        this.refs.table2.reset();
    }
    showCallIcon = (cell, row) => {
        return (
            <OverlayTrigger overlay={(<Tooltip id="callModal">Details for {row.vendorName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showCallModal(row)
                }}><i className="fa fa-info-circle"></i></Link>
            </OverlayTrigger>
        )
    }

    showCallModal = (row) => {
        this.setState({ selectedVendorId: row.vendorId, selectedVendorName: row.vendorName, showCallModal: true }, () => {
            let selections = this.state.selectedVendorId;


            this.props.getVendorFullInfoAPI(selections, (res) => {
                toast(res.data.text);
            });
            this.setState({ showcallModal: false });
        });
    }
    closeCallModal = () => {
        this.setState({ showCallModal: false });
    }
    showCall() {

        let selections = {
            id: this.state.selectedVendorId
        }
        if (this.state.getVendorInfo) {


            this.props.getVendorInfo(selections, (res) => {
                toast(res.data.message);
                this.setState({ showcallModal: false });
            });
        }
        else {
            this.setState({ showCallModal: false });
        }

        //call action now
    }
    showProductListIcon = (cell, row) => {
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">Details for {row.tierFour}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showProductListModal(row)
                }}> <i className="fa fa-info-circle"></i></Link>
            </OverlayTrigger>
        )
    }

    showProductListModal = (row) => {

        this.setState({
            selectedproductGroupId: row.tierFourId, selectedproductGroup: row.tierFour,
            showProductListModal: true, selectedCheckboxes: [], showAllProductFeedbackModal: false,
        }, () => {

            let selections = this.state.params;
            selections = paramsToJSON(selections);
            selections.productGroupId = this.state.selectedproductGroupId;

            selections = jsonToParam(selections);
            console.log(selections);
            this.props.getOutsidePurchaseProductCategoryAPI(selections, (res) => {
                toast(res.data.message);
            });
            // this.setState({ showProductListModal: false});
        });
    }
    closeProductListModal = () => {
        this.setState({ showProductListModal: false });
    }
    showProductFeedbackIcon = (cell, row) => {
        //;
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">Feedback for {row.outVendorName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showProductFeedbackModal(row)
                }}> < i className="fas fa-comment-alt"></i></Link>
            </OverlayTrigger>
        )
    }
    showProductFeedbackModal = (row) => {
        //;
        this.setState({
            productId: row.productId, productName: row.productName, selectedCategoryId: row.productGroupId, productDesc: row.productName,
            selectedCategory: row.productGroupName, outVendorName: row.outVendorName,
            selectedFavorableVp: row.favorableVendor, selectedFavorableVpId: row.favorableVendorId,
            showProductFeedbackModal: true, checkedCheckBox:[] ,
            selectedVendor: row.vendorName,selectedVendorId: row.vendorId
        });

    }

    showAllProductFeedbackModal = (row) => {
        //;
        this.setState({
            productId: row.productId, productName: row.productName, selectedCategoryId: row.productGroupId, productDesc: row.productName,
            selectedCategory: row.productGroupName, outVendorName: row.outVendorName,
            selectedFavorableVp: row.favorableVendor, selectedFavorableVpId: row.favorableVendorId,
            selectedCheckboxes: [],selectedVendor: row.vendorName,selectedVendorId: row.vendorId
        });

    }

    closeAllProductFeedbackModal = () => {
        this.setState({
            showAllProductFeedbackModal: false,
            selectCategoryErrorMessage: '',selectInVendorErrorMessage:'', selectFavorableVpErrorMessage: '',
            suggestedFavorableVendorName: '',suggestedVendorName: '', suggestedCategoryName: '',
            disableVendorDropdown: true,disableInVendorDropdown:true, disableNewProductCategoryDropdown: true,
            showAllProductFeedbackModal: false
        });
    }
    closeProductFeedbackModal = () => {
        this.setState({
            showProductFeedbackModal: false,
            selectCategoryErrorMessage: '',selectInVendorErrorMessage:'', selectFavorableVpErrorMessage: '',
            suggestedFavorableVendorName: '',suggestedVendorName: '', suggestedCategoryName: '',
            disableVendorDropdown: true, disableInVendorDropdown:true,disableNewProductCategoryDropdown: true,
            showAllProductFeedbackModal: false
        });
    }
    handleOnChange(event) {
        this.setState({
            textareaValue: event.target.value,
        })
        this.refs.comment.value = '';
    }

    onRowSelect = (row, isSelected) => {
        
        let productNameList = cloneDeep(this.state.selectedCheckboxes);
        if (isSelected) {
            productNameList.push(row);
            this.setState({ selectedCheckboxes: productNameList });
        } else {
            
            let unCheckedCheckBox = productNameList.filter(
                (item) => item.productId !== row.productId
            );
            
            this.setState({ selectedCheckboxes: unCheckedCheckBox });
        }
        

    };
    onSelectAll = (isSelected, rows) => {
        
        let productNameList = cloneDeep(this.state.selectedCheckboxes);
        if (isSelected) {
            rows.map((item) => {
                productNameList.push(item);
            });
            this.setState({
                selectedCheckboxes: productNameList,
                checkedCheckBox: true,

            });
        } else {
            this.setState({ selectedCheckboxes: [], checkedCheckBox: false });
        }
        
    };

    AllFeedbackButtonFunction = (data) => {
        return this.setState({ showAllProductFeedbackModal: true });
    };

   async sendAllProductFeedback() {
        
        let apiresponse = '';
        for(let i = 0; i<  (this.state.selectedCheckboxes).length ; i++ )
        {
         let feedbackList = this.state.selectedCheckboxes[i];
       // this.state.selectedCheckboxes.forEach(async (feedbackList) => {

            let selections = {
                productDesc: feedbackList.productName,
                productId: feedbackList.productId,
                categoryId: feedbackList.productGroupId,
                categoryName: feedbackList.productGroupName,
                productCategoryWrong: this.state.feedbackToggleForWrongClassification,
                feedbackComment: this.state.textareaValue,
                productNotSold: this.state.feedbackToggleForProductsNotSold,
                suggestedCategoryId: this.state.suggestedCategoryId,
                suggestedCategoryName: (this.state.suggestedCategoryName),
                favorableVendorWrong: this.state.feedbackToggleForFavorableVp,
                favorableVendorId: feedbackList.favorableVendorId,
                favorableVendorName: feedbackList.favorableVendor,
                suggestedFavorableVendorId: this.state.suggestedFavorableVendorId,
                suggestedFavorableVendorName: this.state.suggestedFavorableVendorName,
                feedbackToggleForWrongVendor: this.state.feedbackToggleForWrongVendor,
                vendorDisplayName: feedbackList.outVendorName,
                classificationFlag: "IN",
                suggestedVendorId: this.state.suggestedVendorId,
                suggestedVendorName: this.state.suggestedVendorName,
            

            }
            
            if (this.state.feedbackToggleForWrongClassification || this.state.feedbackToggleForProductsNotSold || this.state.feedbackToggleForFavorableVp || this.state.feedbackToggleForWrongVendor) {
                if (this.state.feedbackToggleForWrongClassification && !this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForFavorableVp && !this.state.feedbackToggleForWrongVendor) {
                    //check if dropdown is chosen
                    if (this.state.suggestedCategoryName) {
                        console.log("Hii 1");
                       await this.props.saveProductFeedbackAPI(selections, (res) => {
                        apiresponse = res.data.text;
                            this.setState({
                                showProductFeedbackModal: false,
                                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                                selectInVendorErrorMessage:'',
                               disableNewProductCategoryDropdown: true,
                                disableVendorDropdown: true,
                               
                                feedbackComment: '', 
                                showAllProductFeedbackModal: false,
                            })
                            //toast(response.data.text, 5000);
                        })
                        //.then(res => apiresponse = res.data.text)
                    } else {
                        //throw error msg
                        apiresponse = 'Please select a Category'
                       // this.setState({ selectCategoryErrorMessage: 'Please select a Category' });
                    }
                }
                else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForFavorableVp && !this.state.feedbackToggleForWrongVendor) {
                    //check if dropdown is chosen
                    if (this.state.suggestedCategoryName) {
                        console.log("Hii 2");
                       await this.props.saveProductFeedbackAPI(selections, (res) => {
                            apiresponse = res.data.text;
                            this.setState({
                                showProductFeedbackModal: false,
                                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                                selectInVendorErrorMessage:'',
                                disableNewProductCategoryDropdown: true,
                                disableVendorDropdown: true, textareaValue: '',
                                feedbackComment: '', productNotSold: '',
                              
                                showAllProductFeedbackModal: false, 
                            });
                        });
                    } else {
                        //throw error msg
                        apiresponse = 'Please select a Category'
                       // this.setState({ selectCategoryErrorMessage: 'Please select a Category' });
                    }
                }
                else if (this.state.feedbackToggleForWrongClassification && !this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForFavorableVp && this.state.feedbackToggleForWrongVendor) {
                    //check if dropdown is chosen
                    if (this.state.suggestedCategoryName && this.state.suggestedVendorName) {
                        console.log("Hii 4");
                        await  this.props.saveProductFeedbackAPI(selections, (res) => {
                            apiresponse = res.data.text;
                            this.setState({
                                showProductFeedbackModal: false,
                                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                                selectInVendorErrorMessage:'',
                                disableNewProductCategoryDropdown: true,
                                disableVendorDropdown: true, textareaValue: '',
                               feedbackComment: '', 
                                showAllProductFeedbackModal: false,
                            });
                        });
                    } else {
                        //throw error msg
                        apiresponse = 'Please select a Category/In supplier'
                        //this.setState({ selectCategoryErrorMessage: 'Please select a Category' });
                    }
                }

                else if (!this.state.feedbackToggleForWrongClassification
                    && !this.state.feedbackToggleForFavorableVp && 
                   !this.state.feedbackToggleForProductsNotSold 
                   && this.state.feedbackToggleForWrongVendor) {
                   //check if dropdown is chosen
                   if (this.state.suggestedVendorName ) {
                       console.log("Hii 5");
                       this.props.saveProductFeedbackAPI(selections, (res) => {
                        apiresponse = res.data.text;
                           
                           this.setState({showProductFeedbackModal: false,showProductListModal:false, 
                               selectCategoryErrorMessage:'',selectFavorableVpErrorMessage:'',
                               selectInVendorErrorMessage:'',
                               suggestedFavorableVendorName:'',suggestedCategoryName:'',
                               feedbackToggleForWrongClassification:'',disableNewProductCategoryDropdown:true,
                               disableVendorDropdown:true,
                               feedbackToggleForFavorableVp:'',feedbackToggleForProductsNotSold:'' });
                       });
                   } else {
                       //throw error msg
                       apiresponse = 'Please select an In supplier'
                    }
               } 
               else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedCategoryName && this.state.suggestedVendorName) {
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        console.log("Hii 7");
                        apiresponse = res.data.text;
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    apiresponse= 'Select Category / In Supplier';
                }
            }



                else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForProductsNotSold && this.state.feedbackToggleForWrongVendor) {
                    //check if dropdown is chosen
                    if (this.state.suggestedCategoryName && this.state.suggestedVendorName) {
                        console.log("Hii 6");
                        await   this.props.saveProductFeedbackAPI(selections, (res) => {
                            apiresponse = res.data.text;
                            this.setState({
                                showProductFeedbackModal: false,
                                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                               
                                disableNewProductCategoryDropdown: true,
                                disableVendorDropdown: true, textareaValue: '',
                                feedbackComment: '', 
                                showAllProductFeedbackModal: false,
                            });
                        });
                    } else {
                        //throw error msg
                        apiresponse = 'Please select a Category'
                        //this.setState({ selectCategoryErrorMessage: 'Please select a Category' });
                    }
                }
                else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForFavorableVp) {
                    //check if dropdown is chosen
                    if (this.state.suggestedCategoryName && this.state.suggestedFavorableVendorName) {
                      
                        if (this.state.suggestedCategoryName) {
                            await  this.props.saveProductFeedbackAPI(selections, (res) => {
                                console.log("Hii 7");
                                apiresponse = res.data.text;
                                this.setState({
                                    showProductFeedbackModal: false,
                                    selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                                    selectInVendorErrorMessage:'',
                                     disableNewProductCategoryDropdown: true,
                                    disableVendorDropdown: true, textareaValue: '',
                                   feedbackComment: '', 
                                    showAllProductFeedbackModal: false, 
                                });
                            });
                        }
                        else  if ( this.state.suggestedFavorableVendorName) {
                            await  this.props.saveProductFeedbackAPI(selections, (res) => {
                                console.log("Hii 7"); 
                                apiresponse = res.data.text;
                                this.setState({
                                    showProductFeedbackModal: false,
                                    selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                                   
                                    disableNewProductCategoryDropdown: true,
                                    disableVendorDropdown: true, textareaValue: '',
                                   feedbackComment: '', 
                                    showAllProductFeedbackModal: false, 
                                });
                            });
                        }
                        
                        else {
                        //throw error msg
                        apiresponse = 'Please select Category/Supplier'
                        //this.setState({ selectCategoryErrorMessage: 'Select Category / Supplier' });
                    }

                    } else {
                        //throw error msg
                        apiresponse = 'Please select a Category/Supplier'
                        //this.setState({ selectCategoryErrorMessage: 'Select Category / Supplier' });
                    }
                }
                else if (this.state.feedbackToggleForWrongVendor && this.state.feedbackToggleForFavorableVp) {
                    //check if dropdown is chosen
                    if (this.state.suggestedVendorName && this.state.suggestedFavorableVendorName) {
                        this.props.saveProductFeedbackAPI(selections, (res) => {
                            console.log("Hii 7");
                            apiresponse = res.data.text;
                            this.setState({
                                showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                                suggestedFavorableVendorName: '', suggestedCategoryName: '',
                                feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                                disableVendorDropdown: true, textareaValue: '',
                                feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                                productDesc: '', productId: '', categoryId: '', categoryName: '',
                                productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                                suggestedCategoryId: '',
                                favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                                suggestedFavorableVendorId: '',
                                feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                            });
                        });
                    } else {
                        //throw error msg
                        apiresponse = 'Select Category / In Supplier';
                    }
                }
    
    

                else if (this.state.feedbackToggleForFavorableVp && !this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForWrongClassification && !this.state.feedbackToggleForWrongVendor) {
                    //check if dropdown is chosen
                    if (this.state.suggestedFavorableVendorName) {
                        console.log("Hii 8");
                      await  this.props.saveProductFeedbackAPI(selections, (res) => {
                            apiresponse = res.data.text;
                            this.setState({
                                showProductFeedbackModal: false,
                                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                                disableNewProductCategoryDropdown: true,
                                disableVendorDropdown: true, textareaValue: '',
                                feedbackComment: '', 
                                showAllProductFeedbackModal: false, 
                            });
                        });
                    } else {
                        //throw error msg
                        apiresponse = 'Please select a Supplier'
                        //this.setState({ selectFavorableVpErrorMessage: 'Please select a vendor' });
                    }
                }
                else if (this.state.feedbackToggleForFavorableVp) {
                    //check if dropdown is chosen
                    if (this.state.suggestedFavorableVendorName) {
                        console.log("Hii 9");
                        await    this.props.saveProductFeedbackAPI(selections, (res) => {
                            apiresponse = res.data.text;
                            this.setState({
                                showProductFeedbackModal: false,
                                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                              disableNewProductCategoryDropdown: true,
                                disableVendorDropdown: true, textareaValue: '',
                              feedbackComment: '', 
                                showAllProductFeedbackModal: false, 
                            });
                        });
                    } else {
                        //throw error msg
                        apiresponse = 'Please select a Supplier'
                       // this.setState({ selectFavorableVpErrorMessage: 'Please select a vendor' });
                    }
                }

                else if (this.state.feedbackToggleForProductsNotSold || this.state.feedbackToggleForWrongVendor) {
                    if (this.state.suggestedVendorName) {
    
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        apiresponse = res.data.text;
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                }
                else {
                    //throw error msg
                    apiresponse = 'Please select an In supplier' ;
                }
            }

            

            }
            else {
                this.setState({
                    showProductFeedbackModal: false,
                    selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                    suggestedFavorableVendorName: '', suggestedCategoryName: '',
                    feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                    disableVendorDropdown: true, textareaValue: '',
                    feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                    productDesc: '', productId: '', categoryId: '', categoryName: '',
                    productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                    suggestedCategoryId: '',
                    favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                    suggestedFavorableVendorId: '',
                    feedbackToggleForWrongVendor: '',
                    showAllProductFeedbackModal: false
                });
            }

        };
        toast(apiresponse, 5000);
        
    }

    sendProductFeedback() {
        
        let selections = {
            productDesc: this.state.productDesc,
            productId: this.state.productId,
            categoryId: this.state.selectedCategoryId,
            categoryName: this.state.selectedCategory,
            productCategoryWrong: this.state.feedbackToggleForWrongClassification,
            feedbackComment: this.state.textareaValue,
            productNotSold: this.state.feedbackToggleForProductsNotSold,
            suggestedCategoryId: this.state.suggestedCategoryId,
            suggestedCategoryName: (this.state.suggestedCategoryName),
            favorableVendorWrong: this.state.feedbackToggleForFavorableVp,
            favorableVendorId: this.state.selectedFavorableVpId,
            favorableVendorName: this.state.selectedFavorableVp,
            suggestedFavorableVendorId: this.state.suggestedFavorableVendorId,
            suggestedFavorableVendorName: this.state.suggestedFavorableVendorName,
            feedbackToggleForWrongVendor: this.state.feedbackToggleForWrongVendor,
            vendorDisplayName: this.state.outVendorName,
            classificationFlag: "IN",
            suggestedVendorId: this.state.suggestedVendorId,
            suggestedVendorName: this.state.suggestedVendorName,
            

        }
       
        if (this.state.feedbackToggleForWrongClassification || this.state.feedbackToggleForProductsNotSold || this.state.feedbackToggleForFavorableVp || this.state.feedbackToggleForWrongVendor) {
            if (this.state.feedbackToggleForWrongClassification && !this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForFavorableVp && !this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedCategoryName) {
                    console.log("Hii 1");
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true,
                            feedbackToggleForFavorableVp: '',
                            textareaValue: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        })
                        toast(res.data.text, 5000);
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Please select a Category' });
                }
            }
            else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForFavorableVp && !this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedCategoryName) {
                    console.log("Hii 2");
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Please select a Category' });
                }
            }
            else if (this.state.feedbackToggleForWrongClassification && !this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForFavorableVp && this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedCategoryName && this.state.suggestedVendorName) {
                    console.log("Hii 4");
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Please select a Category/ In Supplier' });
                }

                
            }
            else if (!this.state.feedbackToggleForWrongClassification
                 && !this.state.feedbackToggleForFavorableVp && 
                !this.state.feedbackToggleForProductsNotSold 
                && this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedVendorName ) {
                    console.log("Hii 5");
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        swal(res.data.text);
                        this.setState({showProductFeedbackModal: false,showProductListModal:false, 
                            selectCategoryErrorMessage:'',selectFavorableVpErrorMessage:'',
                            selectInVendorErrorMessage:'',
                            suggestedFavorableVendorName:'',suggestedCategoryName:'',
                            feedbackToggleForWrongClassification:'',disableNewProductCategoryDropdown:true,
                            disableVendorDropdown:true,
                            feedbackToggleForFavorableVp:'',feedbackToggleForProductsNotSold:'' });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Please select an In Supplier' });
                }
            } 
            else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedCategoryName && this.state.suggestedVendorName) {
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        console.log("Hii 7");
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Select Category / In Supplier' });
                }
            }

            else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForProductsNotSold && this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedCategoryName && this.state.suggestedVendorName) {
                    console.log("Hii 6");
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Please select a Category / In Supplier' });
                }
            }
             else if (this.state.feedbackToggleForWrongClassification && this.state.feedbackToggleForFavorableVp) {
                //check if dropdown is chosen
                if (this.state.suggestedCategoryName && this.state.suggestedFavorableVendorName) {
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        console.log("Hii 7");
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Select Category / Supplier' });
                }
            }
            else if (this.state.feedbackToggleForWrongVendor && this.state.feedbackToggleForFavorableVp) {
                //check if dropdown is chosen
                if (this.state.suggestedVendorName && this.state.suggestedFavorableVendorName) {
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        console.log("Hii 7");
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectCategoryErrorMessage: 'Select Category / In Supplier' });
                }
            }

            else if (this.state.feedbackToggleForFavorableVp && !this.state.feedbackToggleForProductsNotSold && !this.state.feedbackToggleForWrongClassification && !this.state.feedbackToggleForWrongVendor) {
                //check if dropdown is chosen
                if (this.state.suggestedFavorableVendorName) {
                    console.log("Hii 8");
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectFavorableVpErrorMessage: 'Please select a supplier' });
                }
            }
            else if (this.state.feedbackToggleForFavorableVp) {
                //check if dropdown is chosen
                if (this.state.suggestedFavorableVendorName) {
                    console.log("Hii 9");
                    this.props.saveProductFeedbackAPI(selections, (res) => {
                        toast(res.data.text);
                        this.setState({
                            showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                            selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                            suggestedFavorableVendorName: '', suggestedCategoryName: '',
                            feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                            disableVendorDropdown: true, textareaValue: '',
                            feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                            productDesc: '', productId: '', categoryId: '', categoryName: '',
                            productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                            suggestedCategoryId: '',
                            favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                            suggestedFavorableVendorId: '',
                            feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                        });
                    });
                } else {
                    //throw error msg
                    this.setState({ selectFavorableVpErrorMessage: 'Please select a supplier' });
                }
            }
            else if (this.state.feedbackToggleForProductsNotSold || this.state.feedbackToggleForWrongVendor) {
                if (this.state.suggestedVendorName) {

                this.props.saveProductFeedbackAPI(selections, (res) => {
                    toast(res.data.text);
                    this.setState({
                        showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                        selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                        suggestedFavorableVendorName: '', suggestedCategoryName: '',
                        feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                        disableVendorDropdown: true, textareaValue: '',
                        feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                        productDesc: '', productId: '', categoryId: '', categoryName: '',
                        productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                        suggestedCategoryId: '',
                        favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                        suggestedFavorableVendorId: '',
                        feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
                    });
                });
            }
            else {
                //throw error msg
                this.setState({ selectFavorableVpErrorMessage: 'Please select an In supplier' });
            }
        }
    }
        else {
            this.setState({
                showProductFeedbackModal: false,selectInVendorErrorMessage:'',
                selectCategoryErrorMessage: '', selectFavorableVpErrorMessage: '',
                suggestedFavorableVendorName: '', suggestedCategoryName: '',
                feedbackToggleForWrongClassification: '', disableNewProductCategoryDropdown: true,
                disableVendorDropdown: true, textareaValue: '',
                feedbackToggleForFavorableVp: '', feedbackToggleForProductsNotSold: '',
                productDesc: '', productId: '', categoryId: '', categoryName: '',
                productCategoryWrong: '', feedbackComment: '', productNotSold: '',
                suggestedCategoryId: '',
                favorableVendorWrong: '', favorableVendorId: '', favorableVendorName: '',
                suggestedFavorableVendorId: '',
                feedbackToggleForWrongVendor: '', selectedCheckboxes: [], showAllProductFeedbackModal: false
            });
        }
    }


    showFeedbackModal = (row) => {
        //;
        this.setState({ vendorDisplayName: row.vendorName, showFeedbackModal: true });
    }
    closeFeedbackModal = () => {
        this.setState({ showFeedbackModal: false, showSugestedVendorSelect: false, showLPGVendorSelect: false, showVendorNameInput: false });
    }
    showFeedbackIcon = (cell, row) => {
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi" style={{ textTransform: 'capitalize' }} >Out Supplier feedback for {row.vendorName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showFeedbackModal(row)
                }}> <i className="fas fa-comment-alt"></i></Link>
            </OverlayTrigger>
        )
    }
    handleClick = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedVendorId: encodeURIComponent(arr), suggestedVendorName: encodeURIComponent(arr1), ErrorMessage: '' })

    }
    handleCategoryClick = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedCategoryId: encodeURIComponent(arr), suggestedCategoryName: encodeURIComponent(arr1), selectCategoryErrorMessage: '' })

    }
    selectRowProp = {
        mode: "radio",
        hideSelectColumn: true,
        clickToSelect: true,
        hideSelectAll: true,
        bgColor: "rgb(0,123,255)",
    };
    handleVendorNameClick = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedFavorableVendorId: encodeURIComponent(arr), selectFavorableVpErrorMessage: '', suggestedFavorableVendorName: encodeURIComponent(arr1) })
    }

    handleVendorNameClick1 = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedVendorId: encodeURIComponent(arr), selectInVendorErrorMessage: '', suggestedVendorName: encodeURIComponent(arr1) })
    }


    submitForm = row => { 
        let selections = {
            vendorDisplayName: this.state.vendorDisplayName,
            classificationFlag: this.state.classificationFlag,
            suggestedVendorId: this.state.suggestedVendorId,
            suggestedVendorName: this.state.suggestedVendorName,
            feedbackComments: this.state.feedbackComments,

        }
        if (this.state.classificationFlag != "MEMBER_COMPANY" &&
            this.state.classificationFlag != "BRANCH_COMPANY" && this.state.classificationFlag != "NP"  && this.state.classificationFlag != "DIFF_BUYING_GROUP") {

            if (!this.state.suggestedVendorName) {
                this.setState({ ErrorMessage: 'Please select a supplier partner' }, () => {
                });
            } else {
                
                this.setState({ showFeedbackModal:false,suggestedVendorName: '', showLPGVendorSelect: '', showSugestedVendorSelect: '', ErrorMessage: '' }, () => {
                    this.props.saveOutVendorFeedbackAPI(selections, (res) => {
                        toast(res.data.text);
                        this.refs.vendorname.value = '';
                        this.refs.vendordropdown.value = '';
                    });

                });
            }
        }
        else {
            this.setState({ suggestedVendorName: '', showSugestedVendorSelect: '', showLPGVendorSelect: '', ErrorMessage: '' }, () => {
                this.props.saveOutVendorFeedbackAPI(selections, (res) => {
                    toast(res.data.text);
                    this.refs.vendorname.value = '';
                    this.refs.vendordropdown.value = '';
                });

            });

        }
    
    }


    ProgressBarPurchaseInsideIMARK = (cell, row) => {
        //;
        this.MemberPurchaseInsideImarkValue.push(row.memberPurchase)
        let max = Math.max(...this.props.OpportunityList);
        // let str = accounting.formatMoney(cell);
        //str = str.slice(0, -3);
        //;
        return (
            <React.Fragment>
                <OverlayTrigger overlay={(<Tooltip> Member Purchase {PriceFormatter(row.memberPurchase)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="progress">

                        <div className="progress-bar" role="progressbar"
                            aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                        </div>
                    </div>
                </OverlayTrigger>

            </React.Fragment>

        )
        console.log(((cell / max) * 100));
    }
    ProgressBarPurchaseOutsideIMARK = (cell, row) => {
        //;
        //this.MemberPurchaseOutsideImarkValue =[];
        this.MemberPurchaseOutsideImarkValue.push(row.rebateOpportunity)
        let max = Math.max(...this.props.OutsideOpportunityList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                <OverlayTrigger overlay={(<Tooltip> Rebate Opportunity {PriceFormatter(row.rebateOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="progress">

                        <div className="progress-bar" role="progressbar"
                            aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                        </div>
                    </div>
                </OverlayTrigger>

            </React.Fragment>

        )
    }
    ProgressBarPurchaseOutsideIMARKByCategory = (cell, row) => {
        //;
        //this.MemberPurchaseOutsideImarkValue =[];
        this.MemberPurchaseOutsideImarkValueByCategory.push(row.rebateOpportunity)
        let max = Math.max(...this.props.PGOpportunityList);
        // ;
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        //;
        return (
            <React.Fragment>
                <OverlayTrigger overlay={(<Tooltip> Rebate Opportunity {PriceFormatter(row.rebateOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                    <div className="progress">

                        <div className="progress-bar" role="progressbar"
                            aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                        </div>
                    </div>
                </OverlayTrigger>
            </React.Fragment>

        )
    }
    createCustomClearButtonForPurchaseWithinImark= (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{'height': '24px','font-size': '11px','font-weight': '700',
                'font-stretch': 'extra-expanded'}}
                onClick={(e) => this.getPurchseInsideImarkDefaultData(onClick)}
            >
            Clear All
            </button>
        );
    };
    renderPurchaseWithinImark() {
        const { MemberPurchaseWithinImarkValue } = this.props;
        const handleRowClickOfPurchaseWithinImark = {
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForPurchaseWithinImark,
            
        }
        //this.MemberPurchaseInsideImarkValue = [];
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        <div className="card-body" style={{ maxHeight: "390" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}>Purchase Within Imark</h5>
                            
                            <BootstrapTable search options={handleRowClickOfPurchaseWithinImark} height='400' ref = "purchasewithinimarkmember" data={this.props.MemberPurchaseWithinImarkValue} striped sortable hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="280" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='vendorName'>Supplier Name </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={this.ProgressBarPurchaseInsideIMARK} dataSort={true} dataField='memberPurchase'> Purchase Bar</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="280" thStyle={{ whiteSpace: 'normal' }} hidden dataSort={true} dataField='vendorId'></TableHeaderColumn>
                                {/* <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={this.ProgressBarPurchaseInsideIMARK} dataSort={true} dataField='memberPurchase'> Purchase Bar</TableHeaderColumn> */}
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='memberPurchase'>Member Purchase</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='potentialPurchase'>Potential Purchase</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="170" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='potentialRebate'>Potential Rebate</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.showCallIcon} width="80" dataField='vendorId'>InfoLink</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    CriteriaCheckThree = (cell, rows) => {
        //;
        let criteriaThree = _get(rows, 'criteriaThree', 0);
        //
        if (criteriaThree === false) {
            return (<div className="CriteriaCheckThreeTrue" style={{ color: "red" }}>{<i class="fas fa-times"></i>}</div>)
        }
        else {
            return (<div className="CriteriaCheckThreeFalse"><i class="fas fa-check text-success"></i></div>)
        }


    }

    CriteriaCheckTwo = (cell, rows) => {
        //;
        let CriteriaCheckTwo = _get(rows, 'criteriaTwo', 0);
        //
        if (CriteriaCheckTwo === false) {
            return (<div className="CriteriaCheckTwoTrue" style={{ color: "red" }}>{<i class="fas fa-times"></i>}</div>)
        }
        else {
            return (<div className="CriteriaCheckTwoFalse" ><i class="fas fa-check text-success"></i></div>)
        }


    }
    sortAscending = () => {
        const { prices } = this.state;
        prices.sort((a, b) => a - b)
        this.setState({ prices })
    }

    sortDescending = () => {
        const { prices } = this.state;
        prices.sort((a, b) => a - b).reverse()
        this.setState({ prices })
    }
    renderPaginationShowsTotal(start, to, total) {
        return (
            <p style={{ color: '' }}>
                Showing rows { start} to { to}
            </p>
        );
    }

    renderPurchaseWithinImarkwithCriteria() {
        const { MemberPurchaseWithinImarkValue } = this.props;
        const handleRowClickOfPurchaseWithinImark = {
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForPurchaseWithinImark,
            
        }
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: "390" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}>Purchase Within Imark</h5>
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getPurchseInsideImarkDefaultData} > Clear All </button>
                            */}
                            <BootstrapTable search options={handleRowClickOfPurchaseWithinImark} height='400' ref = "purchasewithinimarkmember" data={this.props.MemberPurchaseWithinImarkValue} striped hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="210" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='vendorName'>Supplier Name </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="150" thStyle={{ whiteSpace: 'normal' }} hidden dataSort={true} dataField='vendorId'></TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="130" thStyle={{ whiteSpace: 'normal' }} dataFormat={this.CriteriaCheckTwo} dataSort={true} dataField='criteriaTwo'>Criteria Two</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="130" thStyle={{ whiteSpace: 'normal' }} dataFormat={this.CriteriaCheckThree} dataSort={true} dataField='criteriaThree'>Criteria Three</TableHeaderColumn>
                                
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="150" thStyle={{ whiteSpace: 'normal' }} dataFormat={this.ProgressBarPurchaseInsideIMARK} dataSort={true} dataField='memberPurchase'>Purchase Bar</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="150" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='memberPurchase'>Member Purchase</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="170" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='potentialPurchase'>Potential Purchase</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="160" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='potentialRebate'>Potential Rebate</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.showCallIcon} width="50" dataField='vendorId'>Info</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    OutVendorUpperCase = (cell, rows) => {
        let tier = _get(rows, 'vendorName', "")
        let vendorName = tier;
        if (vendorName) {
            return <div className="vendorName" style={{ textTransform: 'capitalize' }}>{vendorName}</div>
        }
    }

    renderPurchaseOutsideImark() {
        const { MemberPurchaseOutsideImarkValue } = this.props;

        this.MemberPurchaseOutsideImarkValue = [];
        const options = {
            onRowClick: this.handleRowClick,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForOutsidePurchase,
        }

        //const {options} = this.props;
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: "390" }}>

                            {/* <div className="card-header"> */}
                            <h5 style={{ textDecorationLine: 'underline', }}>Purchase Outside IMARK</h5>
                            {/* <button className="btn btn-primary" style={{float:"right",}} onClick={this.getPurchseOutsideImarkDefaultData} > Clear All </button> */}

                            {/* </div> */}
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getPurchseOutsideImarkDefaultData} > Clear All </button> */}

                            <BootstrapTable options={options} ref='table1' selectRow={this.selectRowProp} search height='400' data={this.props.MemberPurchaseOutsideImarkValue} pagination striped hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="130" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataFormat={this.OutVendorUpperCase} dataField='vendorName'>Out Supplier</TableHeaderColumn>

                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="120" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.ProgressBarPurchaseOutsideIMARK} dataField='rebateOpportunity' >Opportunity</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='missedOpportunity'>Purchase </TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.showFeedbackIcon} width="80" dataField='feedback'>Feedback</TableHeaderColumn>
                                {/* <TableHeaderColumn dataSort={true} dataFormat={this.showCommentIcon} dataField='feedback'></TableHeaderColumn> */}

                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    renderMemberOutsidePurchaseByCategory() {
        // ;
        const { MemberOutsidePurchaseByCategory } = this.props;
        this.MemberPurchaseOutsideImarkValueByCategory = [];
        const options = {
            onRowClick: this.handleRowClickOutsidePurchase,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForOutsidePurchaseProductGroup,
        }
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        {/* <div className="card-header">
                        Outside Purchases by Product Group
                        <button className="btn btn-primary" style={{float:"right",}} onClick={this.getProductGroupDefaultData} > Clear All </button>
                            </div> */}
                        <div className="card-body" style={{ maxHeight: "375" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}>Outside Purchases by Product Group</h5>
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getProductGroupDefaultData} > Clear All </button>
                            */}
                            <BootstrapTable options={options} ref='table2' selectRow={this.selectRowProp} search height='400' data={this.props.MemberOutsidePurchaseByCategory} pagination striped hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal', maxWidth: "100" }} dataSort={true} isKey dataField='tierFour'>Product Group</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.ProgressBarPurchaseOutsideIMARKByCategory} dataField='rebateOpportunity'>Opportunity</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='tierFourId'> </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='missedOpportunity'>Purchase </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='favorableVendorName'>FV Supplier</TableHeaderColumn>
                                <TableHeaderColumn dataFormat={this.showProductListIcon} width="80" dataField='tierFourId'>Details</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    // getOptions() {
    //     let params = this.state.params;
    //     params = paramsToJSON1(params);

    //     if (getMemberMonthsFilter != '') {
    //         let items = getMemberMonthsFilter[params.year].map(itemval => {
    //             return {
    //                 label: itemval,
    //                 value: itemval,
    //             }

    //         });
    //     }
    //     else {
    //         return {
    //             label: '',
    //             value: '',
    //         }

    //     }
    // }

    renderSizePerPageDropDown = props => {
        return (
            <div className='btn-group'>
                {
                    [25, 50, 100].map((n, idx) => {
                        const isActive = (n === props.currSizePerPage) ? 'active' : null;
                        return (
                            <button key={idx} type='button' className={`btn btn-info ${isActive}`} onClick={() => props.changeSizePerPage(n)}>{n}</button>
                        );
                    })
                }
            </div>
        );
    }
    render() {
        const selectRowProp1 = {
            mode: 'checkbox',
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll,
            clickToSelect: true,
        };
        let addModalClose = () => this.setState({ addModalShow: false });
        const { showQuarter } = this.state;
        const { monthName } = this.props;
        let items = [];
        const { purchaseWithinImark, purchaseWithinImarkCriteria } = this.state;
        const { MemberPurchaseWithinImarkValue, MemberPurchaseOutsideImarkValue,
            getMemberMonthsFilter, MemberOutsidePurchaseByCategory, cardsDataForMemberDataTab } = this.props;
        let CardSection = [];
        cardsDataForMemberDataTab.map((card, index) => {
            let str = accounting.formatMoney(card.value);
            str = str.slice(0, -3);
            let yoy = '';
            if ((card.lastYearValue) != 0) {
                yoy = ((((card.value) - (card.lastYearValue)) / (card.lastYearValue)) * 100);
            } else {
                yoy = 'NA';
            }
            CardSection.push(
                <GrayCard
                    displayModal={this.displayModalMethod}
                    closeModal={this.closeModal}
                    type={"amount"}
                    title={getCardTitle(card.cardTitle)}
                    amount={str}
                    date={card.year}
                    growthAmount={yoy}
                    growth={yoy >= 0 ? "positive" : "negative"}
                />
            )
        })
        if (_isEmpty(CardSection)) {
            CardSection.push(
                <div className="col-3 errorText">No Data Available</div>
            )
        }

        const options1 = {
            onRowClick: this.handleRowClickCategory,
            sizePerPageDropDown: this.renderSizePerPageDropDown
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        const optionsProductGroup = {
            sizePerPageDropDown: this.renderSizePerPageDropDown
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }

        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        let params = this.state.params;
        params = paramsToJSON1(params);
        console.log(params.year)

        return (

            <div className="Dashboard">
                <ToastContainer style={{ zIndex: '9999' }} />
                <nav className="userInfo Filters navbar">
                    {/* style={{ marginLeft: this.props.isExpanded ? "186px" : "0px" }} */}
                {this.state.addModalShow1 == true ? 
                    <span className="navbar-brand nav-head">{sessionStorage.getItem('imark-memberName')}  (Non-Compliant Member)</span>
                      :
                    <span className="navbar-brand nav-head">{sessionStorage.getItem('imark-memberName')}  (Compliant Member)</span>
                    }
                    <div className="export-button-wrapper" style={{ marginRight: "0px" }}>

                        <Select autosize={true} id="branchvalue" onChange={(e) => this.handleClickBranch(e)}
                            value={this.state.selectedBranch}
                            options={this.state.BranchNames} />
                        <ul className="navbar-nav flexRowForFilters" >
                            <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li>
                            <li className="nav-item">
                                <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                    value={this.state.selectedYear}
                                    options={this.state.yearval} />
                            </li>
                            {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control" style={{ height: '38px', width: '80px' }} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                        <option value="1" selected={params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={params.quarter == 4 ? true : false} >QTR4</option>

                                    </select>

                                </li>
                                :
                                <li className="nav-item">
                                    <Select
                                        onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                        autosize={true}
                                        value={this.state.selectedItem}
                                        options={this.state.items} />

                                </li>
                            }
                        </ul>

                        {/* <Filters defaultMonth={params.month} monthName={monthName(params.month)} setFilter={this.setFilter} /> */}
                        {/* // <li className="nav-item" style={{ listStyle: "none" }}>
                        //     <select defaultYear={params.year} className="form-control" onChange={(e) => { this.handleChangeOfDropdownYear({ name: "year", value: e.target.value }) }}>
                        //         <option value="2020" selected>2020</option>
                        //         <option value="2019">2019</option>
                        //         <option value="2018">2018</option>
                        //         <option value="2017">2017</option>
                        //     </select>
                        // </li> */}


                        <ExcelFile element={<button className="btn btn-primary" style={{ height: '38px', marginLeft: '2px' }}>Export</button>}>
                            <ExcelSheet data={MemberPurchaseWithinImarkValue} name="PurchaseWithinImark">
                                <ExcelColumn label="SUPPLIER NAME" value="vendorName" />
                                <ExcelColumn label="MEMBER PURCHASE" value="memberPurchase" />
                                <ExcelColumn label="POTENTIAL PURCHASE" value="potentialPurchase" />
                                <ExcelColumn label="OPPORTUNITY" value="potentialRebate" />
                            </ExcelSheet>
                            <ExcelSheet data={MemberPurchaseOutsideImarkValue} name="Purchase Outside Imark">
                                <ExcelColumn label="OUT SUPPLIER" value="vendorName" />
                                <ExcelColumn label="PURCHASE" value="missedOpportunity" />
                                <ExcelColumn label="OPPORTUNITY" value="rebateOpportunity" />
                            </ExcelSheet>
                            <ExcelSheet data={MemberOutsidePurchaseByCategory} name="Outside Purchase By Category">
                                <ExcelColumn label="PRODUCT GROUP" value="tierFour" />
                                <ExcelColumn label="PURCHASE" value="missedOpportunity" />
                                <ExcelColumn label="OPPORTUNITY" value="rebateOpportunity" />
                                <ExcelColumn label="FAVOURABLE SUPPLIER" value="favorableVendorName" />
                            </ExcelSheet>
                        </ExcelFile>
                    </div>
                </nav>
                {this.state.isLoading ? matLoader() : <div>
                    {params.year  < 2021 ?

                       <MembershipQualification params={paramsToJSON1(this.state.params)} verifiedSource={false} />
                     
                     : <MembershipQualificationWireframe params={paramsToJSON1(this.state.params)} verifiedSource={false} />}
 
                   
                 {/* <MembershipQualification params={paramsToJSON1(this.state.params)} verifiedSource={false} />
                    
                 <MembershipQualificationWireframe params={paramsToJSON1(this.state.params)} verifiedSource={false} /> */}

                    <div className="row" style={{ paddingTop: "0px" }}>
                        {this.displayModal()}
                        {CardSection}
                    </div>
                    <div className="row" style={{ paddingBottom: "10px", paddingTop: "0px" }}>
                        {/* <div className="col-12">
                            { this.renderPurchaseWithinImark()} */}
                        
                        {purchaseWithinImark && (
                            <div className="col-12">
                                
                                { params.year < 2021 ? 
                                this.renderPurchaseWithinImark()
                                : this.renderPurchaseWithinImark()}
                            </div>
                        )}
                        {purchaseWithinImarkCriteria && (
                            <div className="col-12">
                                { params.year < 2021 ? 
                                this.renderPurchaseWithinImarkwithCriteria()
                                : this.renderPurchaseWithinImark()}
                            </div>
                        )}
                    </div>
                    <div className="row" style={{ paddingBottom: "12px", paddingTop: "0px" }}>
                        <div className="col-5">
                            {this.renderPurchaseOutsideImark()}
                        </div>
                        <div className="col-7">
                            {this.renderMemberOutsidePurchaseByCategory()}
                        </div>
                    </div>


                    {this.state.showFeedbackModal ?

                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                <div className="modal-content" style={{ width: "700px" }}>

                                    {/* <div className="modal-header">
                                        <h5 className="modal-title" >Out Supplier Feedback</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeFeedbackModal() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div> */}
                                    <div className="modal-body" >
                                        <Card className="mb-3">
                                            <Card.Body>
                                                <Form>
                                                    <h3 style={{ textTransform: 'capitalize' }}>Feedback for out supplier {this.state.vendorDisplayName}</h3>
                                                    <Form.Group>
                                                        <Form.Label>How do you want to classify <strong style={{ textTransform: 'capitalize' }}> {this.state.vendorDisplayName}</strong> as?</Form.Label>
                                                        {this.state.classigicationFlag.map(classification =>
                                                            <Form.Check type="radio" key={'FLAG_' + classification.flag} onChange={() => this.handleFlagChange(classification)} name="classificationFlag" value={classification.flag} label={classification.text} />)}
                                                    </Form.Group>
                                                    {this.state.showSugestedVendorSelect ?
                                                        <Form.Group>
                                                            <Form.Label>Select Suggested Supplier</Form.Label>
                                                            <Dropdown name="suggestedVendorId" ref='vendordropdown' clearable onChange={(e, value) => this.handleClick(e, value)}
                                                                placeholder='Select Supplier' search fluid selection
                                                                options={this.props.vendorNamesList}
                                                                value={this.props.value} />
                                                            {/* <Dropdown  name="suggestedVendorId" onChange={(e, value)=>this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} /> */}
                                                        </Form.Group> : ''}
                                                    {this.state.showLPGVendorSelect ?
                                                        <Form.Group>
                                                            <Form.Label>Select Suggested LPG Supplier</Form.Label>
                                                            <Dropdown name="suggestedVendorId" ref='vendordropdown' clearable onChange={(e, value) => this.handleClick(e, value)}
                                                                placeholder='Select Supplier' search fluid selection
                                                                options={this.props.lpgvendorNames}
                                                                value={this.props.value} />
                                                            {/* <Dropdown  name="suggestedVendorId" onChange={(e, value)=>this.handleClick(e, value)} placeholder='Select Supplier' search fluid selection options={this.props.vendorNamesList} /> */}
                                                        </Form.Group> : ''}
                                                    {this.state.showVendorNameInput ?
                                                        <Form.Group>
                                                            <Form.Label>Provide a existing out supplier name</Form.Label>
                                                            <Form.Control name="suggestedVendorName" ref='vendorname' onChange={(e, value) => {
                                                                this.setState({ suggestedVendorName: e.target.value, ErrorMessage: '' });;
                                                            }} />
                                                        </Form.Group> : ''}
                                                    <Button variant="primary" onClick={(e) => { this.submitForm() }} >Submit Feedback</Button>
                                                    <button type="button" onClick={(e) => { this.closeFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>

                                                </Form>
                                                <span className="errorText">{this.state.ErrorMessage}</span>
                                            </Card.Body>
                                        </Card>

                                    </div>

                                    <div className="modal-footer">

                                    </div>
                                </div>
                            </div>
                        </div> : ''

                    }

                    {this.state.showCallModal ?
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                <div className="modal-content" style={{ width: "700px" }}>

                                    <div className="modal-header">
                                        <h5 className="modal-title" >Contact Info for {this.state.selectedVendorName}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeCallModal() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" >
                                        <table className="table" data={this.props.getVendorFullInfo}>
                                            <tbody>

                                                <tr>

                                                    <td>Supplier Id</td>
                                                    <td>  {this.props.getVendorFullInfo.vendorId == 0 ?
                                                        this.state.selectedVendorId :
                                                        this.props.getVendorFullInfo.vendorId}</td>

                                                </tr>
                                                <tr>
                                                    <td>Supplier Name</td>
                                                    <td>  {this.props.getVendorFullInfo.vendorName == 0 ?
                                                        this.state.selectedVendorName :
                                                        this.props.getVendorFullInfo.vendorName}</td>
                                                    {/* <td>{this.props.getVendorFullInfo.vendorName}</td> */}
                                                </tr>
                                                <tr>
                                                    <td>Contact Address</td>
                                                    <td>  {this.props.getVendorFullInfo.address == '' ?
                                                        'NA' :
                                                        this.props.getVendorFullInfo.address}</td>
                                                    {/* <td>{this.props.getVendorFullInfo.address}</td> */}
                                                </tr>

                                                <tr>
                                                    <td>Year</td>
                                                    <td>  {this.props.getVendorFullInfo.year == 0 ?
                                                        'NA' :
                                                        this.props.getVendorFullInfo.year}</td>
                                                    {/* <td>{this.props.getVendorFullInfo.year}</td> */}
                                                </tr>
                                                <tr>
                                                    <td>Phone</td>
                                                    <td>  {this.props.getVendorFullInfo.phone == '' ?
                                                        'NA' :
                                                        this.props.getVendorFullInfo.phone}</td>
                                                    {/* <td>{this.props.getVendorFullInfo.phone}</td> */}
                                                </tr>
                                                <tr>
                                                    <td>Email</td>
                                                    <td>  {this.props.getVendorFullInfo.email == '' ?
                                                        'NA' :
                                                        this.props.getVendorFullInfo.email}</td>
                                                    {/* <td>{this.props.getVendorFullInfo.email}</td> */}
                                                </tr>

                                                <tr>
                                                    <td>Contact Person</td>
                                                    <td>  {this.props.getVendorFullInfo.contactPerson == '' ?
                                                        'NA' :
                                                        this.props.getVendorFullInfo.contactPerson}</td>
                                                    {/* <td>{this.props.getVendorFullInfo.contactPerson}</td> */}
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div >

                                            <span className="errorText">{}</span>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" onClick={(e) => { this.closeCallModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }

                    {this.state.showProductListModal ?
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "1200px" }}>

                                <div className="modal-content" style={{ width: "1200px" }}>

                                    {/* <div className="modal-header">
                    <h5 className="modal-title" >Product List for {this.state.selectedproductGroup}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductListModal() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div> */}
                                    <div className="modal-body" >
                                        <h5 style={{ textDecorationLine: 'underline', }}>Product List for {this.state.selectedproductGroup}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductListModal() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <BootstrapTable search selectRow={selectRowProp1} options={optionsProductGroup} pagination height='400' data={this.props.getOutsidePurchaseProductCategory} striped hover version="4">
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='productId'>Product Id</TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="200px" thStyle={{ whiteSpace: 'normal' }} dataSort={true}  dataField='productName'>Product Name</TableHeaderColumn>
                                            <TableHeaderColumn dataFormat={this.showProductFeedbackIcon} width="80px" dataField='feedback'>Feedback</TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='outVendorName'>Outside Supplier</TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='favorableVendor'>Favorable Supplier </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='favorableVendorId'>Favorable Supplier Id</TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="130px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='productGroupId'> </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="180px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={PriceFormatter} dataField='outsidePurchase'> PURCHASES OUTSIDE($) </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="100px" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='rebateOpportunity'>REBATE($) </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="100px" thStyle={{ whiteSpace: 'normal' }} dataFormat={PercentFormatter} dataSort={true} dataField='rebatePercent'>REBATE(%)</TableHeaderColumn>
                                            {/* <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="60px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='productGroupName'>Product Group Name </TableHeaderColumn> */}
                                        </BootstrapTable>
                                        <div >

                                            <span className="errorText">{}</span>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        {this.state.selectedCheckboxes.length >= 1 ? (
                                            <div class='form-inline' style={{ justifyContent: 'center' }} >
                                                <button type="button" className="btn btn-primary"
                                                    onClick={() => { this.AllFeedbackButtonFunction(this.state.selectedCheckboxes); }}>
                                                    Feedback for All Selected Product
                        </button>
                                            </div>
                                        ) : null}
                                        <button type="button" onClick={(e) => { this.closeProductListModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }
                    {this.state.showProductFeedbackModal ?
                        // this.setState({ disableBhCategoryDropdown: true}),
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                <div className="modal-content" style={{ width: "700px" }}>

                                    <div className="modal-header">
                                        <h5 className="modal-title" >Product Feedback for {this.state.productName}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductFeedbackModal() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" >
                                        <div >
                                            <form>
                                                <div className="form-group feedbackToggle">
                                                    <label >Is <b>{this.state.productDesc}</b> wrongly classified as <b>{this.state.selectedCategory}?</b> </label>
                                                    <Checkbox toggle onChange={(e, value) => {
                                                        if (value.checked) {
                                                            this.setState({ disableNewProductCategoryDropdown: false, selectCategoryErrorMessage: '', hide: true });
                                                        } else {
                                                            this.setState({ disableNewProductCategoryDropdown: true, selectCategoryErrorMessage: '' });
                                                        }
                                                        this.setState({ feedbackToggleForWrongClassification: value.checked });
                                                    }} />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <Dropdown
                                                        placeholder='Select new Product Category'
                                                        search
                                                        disabled={this.state.disableNewProductCategoryDropdown}
                                                        fluid
                                                        selection
                                                        value={this.props.value}
                                                        options={this.props.ProductCategoryList}
                                                        onChange={(e, value) => this.handleCategoryClick(e, value)}
                                                    />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <label >Is <b>{this.state.selectedFavorableVp}</b>  wrong as Favorable Supplier for <b>{this.state.selectedCategory}</b>? </label>

                                                    <Checkbox toggle onChange={(e, value) => {
                                                        if (value.checked) {
                                                            this.setState({ disableVendorDropdown: false, selectFavorableVpErrorMessage: '', hide: false });
                                                        } else {
                                                            this.setState({ disableVendorDropdown: true, selectFavorableVpErrorMessage: '' });
                                                        }
                                                        this.setState({ feedbackToggleForFavorableVp: value.checked });
                                                    }} />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <Dropdown
                                                        placeholder='Select Favorable Supplier'
                                                        disabled={this.state.disableVendorDropdown}
                                                        hidden={this.state.hide}
                                                        fluid
                                                        search
                                                        selection
                                                        value={this.props.value}
                                                        options={this.props.vendorNamesList}
                                                        onChange={(e, value) => this.handleVendorNameClick(e, value)}
                                                    />
                                                </div>


                                                <div className="form-group feedbackToggle">
                                                    <label >Is Supplier <b>{this.state.outVendorName}</b> wrongly classified as out supplier? </label>
                                                    {/* <Checkbox toggle onChange={(e, value) => {
                                                        this.setState({ feedbackToggleForWrongVendor: value.checked });
                                                    }} /> */}
    
                                            <Checkbox toggle onChange={(e, value) => {
                                                        if (value.checked) {
                                                            this.setState({ disableInVendorDropdown: false, selectInVendorErrorMessage: '', hide: false });
                                                        } else {
                                                            this.setState({ disableInVendorDropdown: true, selectInVendorErrorMessage: '' });
                                                        }
                                                        this.setState({ feedbackToggleForWrongVendor: value.checked });
                                                    }} />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <Dropdown
                                                        placeholder='Select In Supplier'
                                                        disabled={this.state.disableInVendorDropdown}
                                                        hidden={this.state.hide}
                                                        fluid
                                                        search
                                                        selection
                                                        value={this.props.value}
                                                        options={this.props.vendorNamesList}
                                                        onChange={(e, value) => this.handleVendorNameClick1(e, value)}
                                                
                                                    />
                                                </div>



                                            
                                                <div className="form-group feedbackToggle">
                                                    <label > <b>{this.state.productDesc}</b> is not sold by any supplier within IMARK? </label>

                                                    <Checkbox toggle onChange={(e, value) => {
                                                        this.setState({ feedbackToggleForProductsNotSold: value.checked });

                                                    }} />

                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <label>Comments</label>
                                                    <textarea ref="comment" rows={4} cols={30} value={this.state.textareaValue}
                                                        onChange={(e, value) => this.handleOnChange(e, value)} />
                                                    {/* }}/> */}
                                                </div>

                                                <span className="errorText">{this.state.selectCategoryErrorMessage}</span>
                                                <span className="errorText">{this.state.selectFavorableVpErrorMessage}</span>
                                                <span className="errorText">{this.state.selectInVendorErrorMessage}</span>

                                            </form>
                                        </div>

                                        <div className="modal-footer">
                                            <button type="button" variant="primary" onClick={(e) => { this.sendProductFeedback() }} className="btn btn-primary" >Submit Feedback</button>
                                            <button type="button" onClick={(e) => { this.closeProductFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }

                    {this.state.showAllProductFeedbackModal ?
                        // this.setState({ disableBhCategoryDropdown: true}),
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                <div className="modal-content" style={{ width: "700px" }}>

                                    <div className="modal-header">
                                        <h5 className="modal-title" >Product Feedback for {this.state.productName}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeAllProductFeedbackModal() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" >
                                        <div >
                                            <form>
                                                <div className="form-group feedbackToggle">
                                                    <label >Are all selected Category wrongly classified ? </label>
                                                    <Checkbox toggle onChange={(e, value) => {
                                                        if (value.checked) {
                                                            this.setState({ disableNewProductCategoryDropdown: false, selectCategoryErrorMessage: '', hide: true });
                                                        } else {
                                                            this.setState({ disableNewProductCategoryDropdown: true, selectCategoryErrorMessage: '' });
                                                        }
                                                        this.setState({ feedbackToggleForWrongClassification: value.checked });
                                                    }} />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <Dropdown
                                                        placeholder='Select new Product Category'
                                                        search
                                                        disabled={this.state.disableNewProductCategoryDropdown}
                                                        fluid
                                                        selection
                                                        value={this.props.value}
                                                        options={this.props.ProductCategoryList}
                                                        onChange={(e, value) => this.handleCategoryClick(e, value)}
                                                    />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <label >Are all selected Favorable Supplier wrong ? </label>

                                                    <Checkbox toggle onChange={(e, value) => {
                                                        if (value.checked) {
                                                            this.setState({ disableVendorDropdown: false, selectFavorableVpErrorMessage: '', hide: false });
                                                        } else {
                                                            this.setState({ disableVendorDropdown: true, selectFavorableVpErrorMessage: '' });
                                                        }
                                                        this.setState({ feedbackToggleForFavorableVp: value.checked });
                                                    }} />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <Dropdown
                                                        placeholder='Select Favorable Supplier'
                                                        disabled={this.state.disableVendorDropdown}
                                                        hidden={this.state.hide}
                                                        fluid
                                                        search
                                                        selection
                                                        value={this.props.value}
                                                        options={this.props.vendorNamesList}
                                                        onChange={(e, value) => this.handleVendorNameClick(e, value)}
                                                    //     this.setState({suggestedFavorableVp:value.value,selectFavorableVpErrorMessage: '' });
                                                    // }}
                                                    />
                                                </div>


                                                <div className="form-group feedbackToggle">
                                                    <label >Are all Supplier wrongly classified as out supplier? </label>
                                                    <Checkbox toggle onChange={(e, value) => {
                                                        if (value.checked) {
                                                            this.setState({ disableInVendorDropdown: false, selectInVendorErrorMessage: '', hide: false });
                                                        } else {
                                                            this.setState({ disableInVendorDropdown: true, selectInVendorErrorMessage: '' });
                                                        }
                                                        this.setState({ feedbackToggleForWrongVendor: value.checked });
                                                    }} />
                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <Dropdown
                                                        placeholder='Select In Supplier'
                                                        disabled={this.state.disableInVendorDropdown}
                                                        hidden={this.state.hide}
                                                        fluid
                                                        search
                                                        selection
                                                        value={this.props.value}
                                                        options={this.props.vendorNamesList}
                                                        onChange={(e, value) => this.handleVendorNameClick1(e, value)}
                                                
                                                    />
                                                </div>

                                                <div className="form-group feedbackToggle">
                                                    <label > Are all selected Product not sold by any supplier within IMARK? </label>

                                                    <Checkbox toggle onChange={(e, value) => {
                                                        this.setState({ feedbackToggleForProductsNotSold: value.checked });

                                                    }} />

                                                </div>
                                                <div className="form-group feedbackToggle">
                                                    <label>Comments</label>
                                                    <textarea ref="comment" rows={4} cols={30} value={this.state.textareaValue}
                                                        onChange={(e, value) => this.handleOnChange(e, value)} />
                                                    {/* }}/> */}
                                                </div>

                                                <span className="errorText">{this.state.selectCategoryErrorMessage}</span>
                                                <span className="errorText">{this.state.selectFavorableVpErrorMessage}</span>
                                                <span className="errorText">{this.state.selectInVendorErrorMessage}</span>

                                            </form>
                                        </div>

                                        <div className="modal-footer">
                                            <button type="button" variant="primary" onClick={(e) => { this.sendAllProductFeedback() }} className="btn btn-primary" >Submit Feedback</button>
                                            <button type="button" onClick={(e) => { this.closeAllProductFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> : ''

                    }

                        <Modelpopup
                            show={this.state.addModalShow}
                            onHide={addModalClose} 
                        />



                </div>}
            </div>


        )

    }
}
function mapStateToProps(state) {
    let vendorNames = [];
    // ;
    let vendorNameprops = _get(state, 'member.getTerminatedVPNamesForMember', []);
    vendorNameprops && vendorNameprops.map((vname, index) => {
        //;
        let vendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId,
        }
        vendorNames.push(vendorNameObj)
        // ;
    })

    let lpgvendorNames = [];
    // ;
    let lpgvendorNameprops = _get(state, 'member.getLPGNamesForMember', []);
    lpgvendorNameprops && lpgvendorNameprops.map((vname, index) => {
        //;
        let lpgvendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId,
        }
        lpgvendorNames.push(lpgvendorNameObj)
        // ;
    })


    let ProductCategory = [];
    // ;
    let ProductCategoryprops = _get(state, 'member.getProductCategory', []);
    ProductCategoryprops && ProductCategoryprops.map((vname, index) => {
        //;
        let ProductCategoryObj = {
            key: index,
            text: vname.productCategory,
            value: vname.productCategoryId,
        }
        ProductCategory.push(ProductCategoryObj)
        // ;
    })



    // ;
    let chartDatafor1 = _get(state, 'member.MemberPurchaseWithinImarkValue', []);
    let chartData1Arr = [];
    if (!_isEmpty(chartDatafor1)) {
        chartDatafor1.map((data, index) => {
            chartData1Arr.push(_get(data, 'memberPurchase', ''));
        })
    }
    else {
        chartData1Arr.push([]);
    }
    let chartDatafor2 = _get(state, 'member.MemberPurchaseOutsideImarkValue', []);
    let chartData2Arr = [];
    if (!_isEmpty(chartDatafor2)) {
        chartDatafor2.map((data, index) => {
            chartData2Arr.push(_get(data, 'rebateOpportunity', ''));
        })
    }
    else {
        chartData2Arr.push([]);
    }
    let chartDatafor3 = _get(state, 'member.MemberOutsidePurchaseByCategory', []);
    let chartData3Arr = [];
    if (!_isEmpty(chartDatafor3)) {
        chartDatafor3.map((data, index) => {
            chartData3Arr.push(_get(data, 'rebateOpportunity', ''));
        })
    }
    else {
        chartData3Arr.push([]);
    }
    let allmember = _get(state, 'member.getMemberBranch', []);
    let allmemberArr = [];
    if (!_isEmpty(allmember)) {
        allmember.map((data, index) => {
            allmemberArr.push(_get(data, 'branchId', ''));
        })
    }
    else {
        allmemberArr.push([]);
    }

    return {
        // items:items,
        allmemberArr1: allmemberArr,

        OpportunityList: chartData1Arr,
        OutsideOpportunityList: chartData2Arr,
        PGOpportunityList: chartData3Arr,
        vendorNamesList: vendorNames,
        lpgvendorNames: lpgvendorNames,
        // vendorNamesList1: vendorNames1,
        ProductCategoryList: ProductCategory,
        getVendorFullInfo: _get(state, 'member.getVendorFullInfo', []),
        getOutsidePurchaseProductCategory: _get(state, 'member.getOutsidePurchaseProductCategory', []),
        MemberPurchaseWithinImarkValue: _get(state, 'member.MemberPurchaseWithinImarkValue', []),
        MemberPurchaseOutsideImarkValue: _get(state, 'member.MemberPurchaseOutsideImarkValue', []),
        MemberOutsidePurchaseByCategory: _get(state, 'member.MemberOutsidePurchaseByCategory', []),
        cardsDataForMemberDataTab: _get(state, 'member.getCardsDataForMemberDataTab', []),
        saveProductFeedbackAPI: _get(state, 'member.saveProductFeedback', []),
        isFetching: _get(state, 'member.isFetching', true),
        memberIdForCorporate: _get(sessionStorage, 'imark-memberId', ''),
        memberIdForCorporate1:  window.sessionStorage.getItem ('imark-memberId'),
        buyingGroupId: _get(sessionStorage, 'imark-buyingGroupId', ''),
        getmemberQualification: _get(state, 'member.getmemberQualification', []),
        getmemberPurchases: _get(state, 'member.getmemberPurchases', []),
        getMemberBranch: _get(state, 'member.getMemberBranch', []),
        getMemberMonthsFilter: _get(state, 'member.getMemberMonthsFilter', []),
        tabTracking: _get(state, 'corporate.tabTracking', []),


    }
}
// console.log("MemberId"+localStorage.getItem('Id'))
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVendorFullInfoAPI: getVendorFullInfo,
        getOutsidePurchaseProductCategoryAPI: getOutsidePurchaseProductCategory,
        getMemberPurchaseWithinImarkValueAPI: getMemberPurchaseWithinImarkValue,
        getMemberPurchaseOutsideImarkValueAPI: getMemberPurchaseOutsideImarkValue,
        getMemberOutsidePurchaseByCategoryAPI: getMemberOutsidePurchaseByCategory,
        getCardsDataForMemberDataTabAPI: getCardsDataForMemberDataTab,
        saveProductFeedbackAPI: saveProductFeedback,
        getMemberVendorNamesAPI: getMemberVendorNames,
        getTerminatedVPNamesForMemberAPI: getTerminatedVPNamesForMember,
        saveOutVendorFeedbackAPI: saveOutVendorFeedback,
        getProductCategoryAPI: getProductCategory,
        getMemberBranchAPI: getMemberBranch,
        getmemberQualificationAPI: getmemberQualification,
        getmemberPurchasesAPI:getmemberPurchases,
        getmemberQualification2021API: getmemberQualification2021,
        getMemberMonthsFilterAPI: getMemberMonthsFilter,
        tabTrackingAPI: tabTracking,
        getLPGNamesForMemberAPI: getLPGNamesForMember,
    },
        dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)((MemberData));
